/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type PreviewKartePlannerCommentQueryVariables = Exact<{
  karteID: string | number;
  comment: string;
  selections: Array<string> | string;
}>;


export type PreviewKartePlannerCommentQuery = { previewKartePlannerComment: { maybeOtherUserNames: Array<string>, preview: { comment: string, selections: Array<string> } } };

export type PreviewKartePlannerCommentPreviewFragment = { maybeOtherUserNames: Array<string>, preview: { comment: string, selections: Array<string> } };

export const PreviewKartePlannerCommentPreviewFragmentDoc = gql`
    fragment PreviewKartePlannerCommentPreview on PreviewKartePlannerCommentPayload {
  preview {
    comment
    selections
  }
  maybeOtherUserNames
}
    `;
export const PreviewKartePlannerCommentDocument = gql`
    query previewKartePlannerComment($karteID: ID!, $comment: String!, $selections: [String!]!) {
  previewKartePlannerComment(
    karteID: $karteID
    comment: $comment
    selections: $selections
  ) {
    preview {
      comment
      selections
    }
    maybeOtherUserNames
  }
}
    `;

/**
 * __usePreviewKartePlannerCommentQuery__
 *
 * To run a query within a Vue component, call `usePreviewKartePlannerCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewKartePlannerCommentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePreviewKartePlannerCommentQuery({
 *   karteID: // value for 'karteID'
 *   comment: // value for 'comment'
 *   selections: // value for 'selections'
 * });
 */
export function usePreviewKartePlannerCommentQuery(variables: PreviewKartePlannerCommentQueryVariables | VueCompositionApi.Ref<PreviewKartePlannerCommentQueryVariables> | ReactiveFunction<PreviewKartePlannerCommentQueryVariables>, options: VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>(PreviewKartePlannerCommentDocument, variables, options);
}
export function usePreviewKartePlannerCommentLazyQuery(variables?: PreviewKartePlannerCommentQueryVariables | VueCompositionApi.Ref<PreviewKartePlannerCommentQueryVariables> | ReactiveFunction<PreviewKartePlannerCommentQueryVariables>, options: VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>(PreviewKartePlannerCommentDocument, variables, options);
}
export type PreviewKartePlannerCommentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PreviewKartePlannerCommentQuery, PreviewKartePlannerCommentQueryVariables>;